import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import './Contact.css';

export default function Contact () {

    const formRef = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('portfolio_contact', 'template_352gpxh', formRef.current, 'HZ9fUEJ8QL1yT4TFh')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });

            e.target.reset();
    };
    
        return (
            <div className="contact-container">
                <div className="contact">
                    <h1 className="contact-title">Contact me!</h1>
                    <div className="contact-form">
                        <form ref={formRef} onSubmit={sendEmail}>
                            <div className="form-group">
                                <label htmlFor="from_name">Name</label>
                                <input type="text" name="from_name" id="name" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="from_email">Email</label>
                                <input type="email" name="from_email" id="email" />
                            </div>
                            <div className="form-group">
                                {/* <label htmlFor="message">Message</label> */}
                                <textarea name="message" id="message" cols="30" rows="10" placeholder="Message..."></textarea>
                            </div>
                            <div className="form-group">
                                <button type="submit">Send</button>
                            </div>
                        </form>
                    </div>
                </div>
                {/* add social icons and more general information also */}
            </div>
        )
    }
